// TODO: STUDY HOW TO IMPLEMENT GSAP TYPO
const initGallerygWidget = () => {
    const gallerySelector = "[data-gsap-gallery-container]";
    const gallery = document.querySelector(gallerySelector);
    if (gallery) {
        if (window.innerWidth > 1180) {
            const generateScriptsGSAP = new Promise((resolve) => {
                function appendScript(src) {
                    return new Promise((resolve) => {
                        const script = document.createElement("script");
                        script.src = src;
                        script.onload = resolve;
                        document.body.appendChild(script);
                    });
                }
                // Check if GSAP and ScrollTrigger are already loaded before appending
                // @ts-ignore
                const gsapLoaded = typeof gsap !== "undefined";
                // @ts-ignore
                const scrollTriggerLoaded = typeof ScrollTrigger !== "undefined";
                const scriptsToLoad = [];
                if (!gsapLoaded) {
                    scriptsToLoad.push("https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.2/gsap.min.js");
                }
                if (!scrollTriggerLoaded) {
                    scriptsToLoad.push("https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.2/ScrollTrigger.min.js");
                }
                if (scriptsToLoad.length === 0) {
                    // Both scripts are already loaded, no need to append
                    resolve(null);
                }
                else {
                    // Load and append the required scripts
                    Promise.all(scriptsToLoad.map(appendScript)).then(resolve);
                }
            });
            generateScriptsGSAP.then(() => {
                // @ts-ignore
                const sections = gsap.utils.toArray("[data-gsap-gallery]");
                const sectionCount = sections.length;
                const xPercentValue = -((sectionCount - 6) * 10 + 70);
                // @ts-ignore
                const scrollTween = gsap.to(sections, {
                    xPercent: xPercentValue * (sections.length - 1),
                    ease: "none",
                    scrollTrigger: {
                        trigger: gallery,
                        pin: true,
                        scrub: 0.1,
                        end: "+=3000",
                    },
                });
            });
        }
        else {
            let config = new CarouselConfig();
            const responsiveCarousel = new ResponsiveCarousel();
            setTimeout(() => {
                config = new CarouselConfig();
                config.sliderSelector = gallerySelector;
                config.cellAlign = CellAlign.left;
                config.contain = true;
                config.showDots = false;
                const createdGalleryArray = responsiveCarousel.initCarousel(config);
            }, 200);
        }
    }
};
